<!-- Start: Multi line text -->
<app-element-container
  [element]="element"
  [index]="index"
  [hasEntries]="hasEntries"
  [allElements]="allElements"
  (remove)="elementRemove.emit(element)"
  (manage)="elementManage.emit(element)"
  (moveUp)="elementMoveUp.emit(element)"
  (moveDown)="elementMoveDown.emit(element)"
  (addMessage)="messageAdd.emit(element)"
  (editMessage)="messageEdit.emit($event)"
  (removeMessage)="messageRemove.emit($event)"
  (visibilityEdit)="visibilityEdit.emit(element)">
  <div class="form-element-answer multi-line-text">
    <textarea [placeholder]="element.placeholder"></textarea>
  </div>
</app-element-container>
<!-- End: Multi line text -->
